import { render, staticRenderFns } from "./KothonService.vue?vue&type=template&id=55b708db&scoped=true"
import script from "./KothonService.vue?vue&type=script&lang=js"
export * from "./KothonService.vue?vue&type=script&lang=js"
import style0 from "./KothonService.vue?vue&type=style&index=0&id=55b708db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b708db",
  null
  
)

export default component.exports